import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";

const TITLE = "Calculatrice du rapport P/E";
const DESCRIPTION =
  "Calculatrice du rapport P/E. Outil financier en francais pour obtenir un calcul rapide, clair et exploitable pour vos decisions de budget, prix et rentabilite.";
const KEYWORDS =
  "rapport p e, calculatrice financiere, budget, rentabilite, marge, gestion des couts, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/pe-ratio/";

function PeRatioCalculator() {
  const [stockPrice, setStockPrice] = useState("");
  const [earnings, setEarnings] = useState("");
  const [result, setResult] = useState(null);

  const calculate = () => {
    if (!stockPrice || !earnings) return;
    const price = parseFloat(stockPrice);
    const eps = parseFloat(earnings);
    if (eps === 0) {
      alert("Le BPA ne peut pas être zéro");
      return;
    }
    const peRatio = price / eps;
    setResult({ price: price.toFixed(2), eps: eps.toFixed(2), peRatio: peRatio.toFixed(2) });
  };

  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>Comment calculer le ratio P/E</h2>
                <p>
                  Le ratio Prix/Benefices (P/E) se calcule en divisant le cours de l'action par le benefice par action (BPA) :
                </p>
                <p>Ratio P/E = Cours de l'action / Benefice par action (BPA)</p>
                <p>
                  Ce ratio est utilise pour evaluer si une action est sous-evaluee ou sur-evaluee par rapport a ses benefices.
                  Il indique combien les investisseurs sont prets a payer pour chaque euro de benefice.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group">
                    <label>Prix de l'action:</label>
                    <input type="number" value={stockPrice} onChange={(e) => setStockPrice(e.target.value)} className="form-control" />
                  </div>
                  <div className="form-group">
                    <label>Bénéfice par action (BPA):</label>
                    <input type="number" value={earnings} onChange={(e) => setEarnings(e.target.value)} className="form-control" />
                  </div>
                  <button onClick={calculate} className="btn btn-success w-100">Calculer</button>
                </div>
              </div>
              <div className="col-sm-12 col-md-6">
                {result && (
                  <div className="bg-light p-3 rounded">
                    <h3>Ratio P/E</h3>
                    <p><strong>Prix de l'action:</strong> {result.price}</p>
                    <p><strong>BPA:</strong> {result.eps}</p>
                    <p><strong>Ratio P/E:</strong> {result.peRatio}</p>
                  </div>
                )}
              </div>
              <hr />
              <div className="row"><RelatedLinks /><hr /></div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds /><br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Qu'est-ce que le ratio P/E ?</h3></div>
              <div className="info-section-body">
                <p>Le ratio cours sur benefices (P/E) est l'un des indicateurs boursiers les plus utilises. Il mesure le prix qu'un investisseur est pret a payer pour chaque euro de benefice genere par l'entreprise.</p>
                <p>Un P/E eleve peut indiquer que le marche anticipe une forte croissance future, tandis qu'un P/E faible peut signaler une action sous-evaluee ou un secteur en difficulte.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comment interpreter le ratio P/E ?</h3></div>
              <div className="info-section-body">
                <ul>
                  <li>P/E inferieur a 15 : generalement considere comme faible / potentiellement sous-evalue</li>
                  <li>P/E entre 15 et 25 : valorisation raisonnable pour la plupart des secteurs</li>
                  <li>P/E superieur a 25 : valorisation elevee, souvent associee a des entreprises de croissance</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row"><div className="col-12 col-md-8"><br /><SecondAds /></div></div>
    </div>
  );
}

export default PeRatioCalculator;